
import locale from 'element-ui/lib/locale/lang/en'

export default {
  loadText: 'Welcome to visit the official website of Ningbo Today Food, loading, please wait...',
  title: 'Ningbo Today Food Co., Ltd.',
  nav: {
    about: 'WORLD OF TODAY',
    products: 'KINGDOM OF TODAY',
    medias: 'TOP NEWS',
    contact: 'CONTACT US',
    base: 'Production base',
    human: 'Human resources'
  },
  seaTitle: 'New Today, New Life',
  homeTitle1: {
    title: 'KINGDOM OF TODAY',
    sub: 'PRODUCTS'
  },
  homeTitle2: {
    title: 'NEWS',
    sub: 'NEWS'
  },
  home: {
    deep: {
      title1: 'With its full ability',
      title2: 'To create an international brand',
      title3: 'And establish an enterprise with hundred years!',
      content: "China's large-scale tuna production base--Ningbo Today Food Co., Ltd., was founded in 2000. It is a comprehensive food processing enterprise which is mainly engaged in the production of all kinds of frozen food, canned food, Freeze dried food and marine biological products.Focusing on providing eco-green, healthy and nutritious foods for people all over the world, it emphasizes quality of life and moves toward to the world's leading brands in the food industry....",
      ul: [
        'Leading enterprise of national agricultural industrialization',
        'National agricultural product processing model enterprise',
        'Leading Agricultural Enterprise of Zhejiang',
        'Leading Food Export Enterprise of Ningbo'
      ],
      count: [
        'Workers',
        'Factory Area',
        'Construction Area',
        'Annual productivity',
        'Datas by January 2019'
      ]
    },
    Island: {
      text1: 'How to demonstrate the gourmet food from the ocean?',
      text2: 'Professional fishing team',
      text3: 'Relying on the fishing resources of Ocean Family, Ningbo Today Food has extended the range of fishing the Pacific Ocean, the Indian Ocean and the southwestern Atlantic Ocean. '
    },
    what: {
      title: 'Gifts of the ocean · Delicious at the tip of your tongue',
      sub: 'A Self-introduction from Tuna',
      info: 'I am a "marine marathon" athlete and I am also a source of delicious nutrition.Why do you say that? Because my meat is tender and delicious, no pollution, the opal content is as high as 20%, and the fat content is very low, commonly known as "sea chicken"! High nutritional value,Rich in unsaturated fatty acids, DHA, EPA, the amino acids contain vitamins, rich in iron, potassium, calcium, magnesium, iodine and other minerals and trace elements, is a great food for women to lose weight and beauty!Fresh and delicious, nutritious and delicious, deeply loved by customer, Europe, America, Japan, Australia, etc., is a rare and healthy food for modern people.Eco-ocean healthy and delicious are all from "I"!'
    }
  },
  about: {
    menu: {
      about: 'Company Profile',
      story: 'Brand story',
      movie: 'Videos',
      honor: 'Qualification and Honor',
      history: 'Development history'
    },
    base: {
      title: "China's large tuna production base",
      text: 'Ningbo Today Food Co., Ltd. Was founded in 2000. It is a comprehensive food export processing enterprise which mainly focuses in the production and operation of all kinds of frozen food, canned food, freeze dried food and marine biological products. The company is located in the national AAAAA scenic spot with beautiful scenery and long history. It has more than 1,000 employees. The factory covers an area of 45,000 square meters and has a construction area of 30,000 square meters. It has a cold storage of more than 4,000 tons. The annual productivity is about 50,000 tons raw tuna. Striving and innovation have enabled us to obtain  "leading agricultural enterprises of Zhejiang ", "leading food export company of Ningbo " and many other awards, giving not only the confidence but also more responsibility to the company.',
      info: [
        'In order to keep pace with international consuming trend,Today Food makes continuous effort in making fully use of tuna by products to develop high value products which includes ocean bio-tech products such as refined fish oil,Polypeptide-k and so on',
        'It will focus on providing new,green and healthy food for consumers and march on the renowned brands in the world food industry.'
      ],
      title2: 'Healthy and delicious mouthpieces make the world famous'
    },
    story: {
      banner: 'Fresh Life Begins Today',
      text1: {
        title: 'Origin - today',
        sub: 'Develop cooperation and seek mutual benefit',
        info: 'Over the years, the company has established itself in Ningbo, radiating the world with its broad mind, pioneering spirit of adventure, practical quality of hardship and endurance, and never giving up its tenacious will. Its abundant production capacity has greatly met the market demand of many regions and countries in Europe, America and Japan, thus creating a good international reputation.'
      },
      text2: {
        title: 'Healthy and delicious casting word of mouth',
        sub: 'Develop cooperation and seek mutual benefit',
        info: [
          'The products are exported to Asian markets such as America, Europe, Middle East, Japan, Australia and so on, and constantly open up new markets. At present, customers have been distributed in more than 30 countries and regions on five continents, and established long-term strategic cooperation with world-renowned enterprises in the industry. Established a sound international sales network, and achieved honor and confidence.',
          'Today, with the concept of "fresh life begins today", we are committed to striving for the vision of creating a healthy cause for all mankind.'
        ]
      }
    },
    movie: {
      banner: 'Image Blockbuster'
    },
    honor: {
      banner: 'Fresh Life Starts From Today'
    },
    history: {
      banner: 'Fresh Life Starts From Today'
    }
  },
  productgroups: {
    banner: "Delicious food, same with love, is precious",
    brand: {
      title: 'Gift from the ocean, delicious at the tip of the tongue',
      detail: 'I am a "marine marathon" athlete and I am also a source of delicious nutrition.<br>Fresh and delicious, delicious and delicious, it is deeply loved by customers in Europe, America, Japan, Australia, etc. It is a rare and healthy food for modern people.<br>Eco-ocean healthy and delicious are all from "I"!'
    }
  },
  products: {
    banner: 'Fresh Life Begins Today'
  },
  product: {
    head: [
      '',
      '',
      '',
      ''
    ]
  },
  medias: {
    banner: 'News Media'
  },
  contact: {
    banner: 'CONTACT',
    title: 'Ningbo Today Food Co., Ltd.',
    info: [
      'No. 38, Zhongxing East Road, Xikou, Fenghua, Ningbo, China',
      'Zip code: 315502',
      'Phone: 0086-574-88847563',
      'Fax: 0086-574-88845098',
      'Website: www.todayfood.com.cn',
      'Email: todayfood@todayfood.com.cn'
    ],
    content: [
      {
        title: 'Media consultation',
        info: 'E-mail:todayfood@todayfood.com.cn'
      },
      {
        title: 'Marketing',
        info: 'Contact: 0086-574-88847563'
      },
      {
        title: 'Brand protection',
        info: 'Complaints and suggestions: 0086-574-88847563'
      }
    ]
  },
  human: {
    banner: 'Good Time And Place',
    content: {
      title: 'What is the most important in the 21st century?',
      sub: 'Opportunities vouchsafed by Heaven are less important than terrestrial advantages, which in turn are less important than the unity among people',
      text: 'Both ability and political integrity, with morality first',
      info: `The company's talent outlook is positioned as "having both virtue and talent, taking virtue as the first." We pay more attention to ability and morality in diploma. Virtue without talent is difficult to take on a major task, and talent without virtue is not practical. We respect knowledge and talents. We emphasize that the company is a whole. The company needs teamwork to work together. "A gentleman loves money and takes it wisely" will be the minimum ethical code of conduct that the company requires you to adhere to all the time. Loyalty to the company, dedication to the cause, and responsibility for your own personality will be an important criterion to measure you.`
    },
    title1: 'Employee Elegance',
    title2: 'Talent Recruitment'
  },
  job: {
    title: 'Talent Recruitment',
    sub: 'Opportunities vouchsafed by Heaven are less important than terrestrial advantages, which in turn are less important than the unity among people',
    form: {
      name: 'Name:',
      sex: {
        label: 'Gender:',
        placeholder: 'Please choose gender',
        option: [
          'male',
          'female'
        ]
      },
      marriage: {
        label: 'Marriage:',
        placeholder: 'Please choose your marital status',
        option: [
          'unmarried',
          'married',
          'Divorce'
        ]
      },
      nation: 'Nation:',
      age: 'Age:',
      place: 'Place:',
      edu: {
        label: 'Degree of Education:',
        placeholder: 'Please choose your education level',
        option: [
          'Specialty',
          'Bachelor degree or above',
          'Other'
        ]
      },
      school: 'School:',
      major: 'Major:',
      time: 'Graduation time:',
      lang: 'Foreign language proficiency:',
      post: 'Position:',
      phone: 'Phone:',
      desc: 'Curriculum vitae:',
      submit: 'Submit:'
    }
  },
  base: {
    banner: 'How to deduce the delicacy of the ocean?',
    content: {
      title: "To devote one's life to proud work",
      sub: 'We continue to succeed',
      info: [
        {
          title: 'Precipitation of Brand Management Beginning in the 21st Century',
          text: 'Ningbo Today Food Co., Ltd., a large tuna production base in China, was founded in 2000. It is a comprehensive food export processing enterprise which mainly produces frozen food, canned food, vacuum dried food and marine biochemical products.'
        },
        {
          title: 'Professional fishing teams',
          text: 'Various advanced fishing methods, such as purse seine fishing and longline fishing, are adopted. Expanding fish species and fishing depth, and timely transporting tuna to the base for processing through its own transport fleet to ensure that the products are first fresh.'
        },
        {
          title: 'An ocean trip',
          text: 'Today, relying on the ocean family fishing resources, the species of fishing stocks have been extended to the Pacific Ocean, Indian Ocean and the southwestern Atlantic Ocean. Ocean fishing strength ranks first-class in China!'
        },
        {
          title: 'Selection Harvest',
          text: 'Require oneself with international standard, put food safety problem in the first place. Strictly control the production process and food hygiene to ensure that every product today meets the ecological and green requirements.'
        },
        {
          title: 'Efficient imported equipment',
          text: 'Equipment is the basic guarantee of product quality. The company continuously strengthens production equipment, imports FD high-tech production lines, tuna cooking and canning equipment from Denmark, the United States, Thailand and other places. The whole process is fully controlled by computer curve, which ensures the excellent quality of products while improving production.'
        },
        {
          title: 'International Quality Standards',
          text: 'The production process not only strictly implements ISO 9001:2008 quality management system and ISO 14001:2004 environmental system certification, but also is a registered aquatic product factory of EU and HACCP certification factory of transporting American aquatic products. The products have passed EFSIS inspection, QS certification, Judaism OU certification, Halal HALAL certification and Dolphin Protection Organization EII certification.'
        },
        {
          title: 'Scientific Research Investment Aids Development',
          text: 'The company attaches great importance to the investment of scientific research and establishes an independent R&D center with 20 sets of test and analysis equipment for product quality inspection and new product development. With Zhejiang University, Jiangnan University, Ningbo University and other institutions of higher learning and scientific research, a "Ningbo Science and Technology Service Team for Comprehensive Utilization of Food Resources, Deep Processing Product Development and Quality and Safety Control" has been established, and the first domestic demonstration base for comprehensive processing, utilization and high value of tuna has been established.'
        },
        {
          title: 'Accurate Matching',
          text: [
            "The selected high quality parts will be matched by our experts according to their respective characteristics with the most accurate mixing and proportion control. Serious and responsible attitude can satisfy people's preferences for different styles and tastes: mellow, sweet, balanced, round and so on.",
            'There are four production lines for canned tuna, twelve production lines for fillet, two production lines for mackerel and other aquatic products, as well as refrigerators of more than 4000 tons, which produce more than 50,000 tons of all kinds of food annually.'
          ]
        }
      ],
      title2: 'Sealed delicacies'
    }
  },
  Morebtn1: 'MORE',
  Morebtn2: 'Back',
  btn1: 'READ MORE',
  btn2: 'Back',
  btn3: 'Back',
  btn4: 'Immediate application',
  swipe1: 'Social Public Welfare',
  footerTop: {
    text: 'New Today, New Life!'
  },
  footerMap: [{
    id: 0,
    title: 'WORLD of TODAY',
    list: [{
      id: 0,
      title: 'Company Profile',
      link: '/#/about'
    }, {
      id: 1,
      title: 'Brand story',
      link: '/#/story'
    }, {
      id: 2,
      title: 'Videos',
      link: '/#/movie'
    }, {
      id: 3,
      title: 'Qualification and Honor',
      link: '/#/honor'
    }, {
      id: 4,
      title: 'Development history',
      link: '/#/history'
    }]
  }, {
    id: 1,
    title: 'Kingdom of Today',
    list: [{
      id: 0,
      title: 'Canned Tuna',
      link: '/#/products/76'
    }, {
      id: 1,
      title: 'Tuna Loin',
      link: '/#/products/77'
    }, {
      id: 2,
      title: 'Pet Food',
      link: '/#/products/78'
    }, {
      id: 3,
      title: 'Marine Health Care Products',
      link: '/#/products/79'
    }, {
      id: 4,
      title: 'FD Product',
      link: '/#/products/80'
    }, {
      id: 5,
      title: 'Other Products',
      link: '/#/products/113'
    }]
  }, {
    id: 2,
    title: 'Production Base',
    list: [{
      id: 0,
      title: 'Production Site',
      link: '/#/base'
    }]
  }, {
    id: 3,
    title: 'Top News',
    list: [{
      id: 0,
      title: 'Company News',
      link: '/#/medias/18'
    }, {
      id: 1,
      title: 'Focusings',
      link: '/#/medias/19'
    }, {
      id: 2,
      title: 'Industry Information',
      link: '/#/medias/20'
    }]
  }, {
    id: 4,
    title: 'Human Resources',
    list: [
      {
        id: 0,
        title: 'Talent Strategy',
        link: '/#/human'
      }
      // , {
      //   id: 1,
      //   title: '人才招聘',
      //   link: ''
      // }
      // , {
      //   id: 2,
      //   title: '人才招聘'
      // }
    ]
  }, {
    id: 5,
    title: 'contact us',
    list: [{
      id: 0,
      title: 'Contact information',
      link: '/#/contact'
    }]
  }],
  footGroup: {
    name: 'Today food',
    add: [
      'Fenghua Xikou, Ningbo, China',
      '38 Zhongxing East Road'
    ]
  },
  footLetter: {
    text1: 'Send your email,',
    text2: 'Receive feedback immediately!'
  },
  footBottom: {
    text1: '© 1992-2021 .todayfood.com .All Rights Reserved.浙ICP备19020653号-1  ',
    link: [
      'Legal statement|',
      'Copyright information|',
      'Contact Us'
    ],
    text2: 'Ningbo Today Food Co., Ltd. All rights reserved 浙ICP备19020653号-1  ',
    text3: [
      'Power By:',
      'Seniorweb'
    ]
  },
  mediasLinkNum: '18',
  mediasMenu: [
    {
      id: 0,
      url: '/medias/18',
      text: 'Enterprise Dynamics'
    },
    {
      id: 1,
      url: '/medias/19',
      text: 'Media Focus'
    },
    {
      id: 2,
      url: '/medias/20',
      text: 'Industry Information'
    }
  ],
  chooseLang: 'Language: English',
  langBox: {
    title: 'Speech Selection',
    menu: [
      'Chinese',
      'English',
      'Japanese'
    ]
  },
  // element-ui
  ...locale
}
